import { render, staticRenderFns } from "./StepperVertical.vue?vue&type=template&id=21150113"
import script from "./StepperVertical.vue?vue&type=script&lang=js"
export * from "./StepperVertical.vue?vue&type=script&lang=js"
import style0 from "./StepperVertical.vue?vue&type=style&index=0&id=21150113&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VStepper,VStepperContent,VStepperStep,VToolbar})
